import { LoanEffects } from '@features/loan/store';

export * from './loan.effects';
export const loanEffects = [LoanEffects];
